'use client';
import React from 'react';

/**
 * Represents the inner context value for the Calendar component.
 */

export var CalendarContext = /*#__PURE__*/React.createContext({});
export var CalendarProvider = CalendarContext.Provider;